import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PrintOfficePage } from './print-office.page';
import { PrintOfficeAvailabilityPage } from '../provider/print-office-availability/print-office-availability.page';
import { PrintOrderDetailsPage } from '../provider/print-order-details/print-order-details.page';

const routes: Routes = [
  {
    path: '',
    component: PrintOfficePage,
  },
  {
    path: 'availability',
    component: PrintOfficeAvailabilityPage,
  },
  {
    path: "order-details/:id",
    component: PrintOrderDetailsPage,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrintOfficePageRoutingModule {}
